<template>

<div v-if="this.checkMobile()" class="grey-background-container">
        <!-- Mobile Screen -->
      <MobileNavigationBack :moduleRoute="moduleRoute" :appbarTitle="appbarTitle"></MobileNavigationBack>
            <div class="p-2">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 p-5">
        <!-- <jet-button @click="back"  class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" >Back</jet-button> -->

          &nbsp;
        </div>
        <div class="max-w-7xl mx-auto">
          <div class="w-full">
            <div class="pb-8 mb-2">
              <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->
              <form @submit.prevent="submit">
                <BsEdit  :createDef="createDef"  :routeDef="moduleRoute" :modelData="modelData"  ref="formRenderer">
                </BsEdit>
                <div class="panel-footer mt-2 text-right">
              
                  <jet-button
                    v-show="!checkAction()"
                    type="submit"
                    class="
                    w-full text-center justify-center 
                      bg-green-500
                      text-sm
                      rounded
                      pl-2
                      pr-2
                      pt-1
                      hover:bg-green-500
                      text-white
                      hover:no-underline
                    "
                  >
                    Create
                  </jet-button>

                  <!-- <jet-button
                    v-show="checkAction()"
                    @click="editItem"
                    class="
                      bg-blue-500
                      rounded
                      text-sm
                      pl-2
                      pr-2
                      pt-1
                      pb-1
                      text-white
                      hover:no-underline
                    "
                  >
                    Update
                  </jet-button> -->
                </div>
              </form>
            </div>
        
        <DxToast
          v-model:visible="isVisible"
          v-model:message="message"
          v-model:type="type"
        />

          </div>
        </div>
    </div>
    </div>
    
    <div v-else>
      <app-layout :title="title" >
        
        <!-- <template v-slot:header>
          <h2>Create</h2>
        </template> -->

        <PageTitle :headerTitle="title"> </PageTitle>

        <br>
    <template v-slot:tcsetttingnav>
    </template>
     <template v-slot:tcmainnav>
    </template>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <jet-button @click="back"  class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" >Back</jet-button>

          &nbsp;
        </div>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
          <div class="w-full">
            <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
              <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->
              <form @submit.prevent="submit">
                <BsEdit  :createDef="createDef"  :routeDef="moduleRoute" :modelData="modelData"  ref="formRenderer">
                </BsEdit>
                <div class="panel-footer mt-2">
              
                  <jet-button
                    v-show="!checkAction()"
                    type="submit"
                    class="
                      bg-green-500
                      text-sm
                      rounded
                      pl-2
                      pr-2
                      pt-1
                      hover:bg-green-500
                      text-white
                      hover:no-underline
                    "
                  >
                    Submit
                  </jet-button>

                  <!-- <jet-button
                    v-show="checkAction()"
                    @click="editItem"
                    class="
                      bg-blue-500
                      rounded
                      text-sm
                      pl-2
                      pr-2
                      pt-1
                      pb-1
                      text-white
                      hover:no-underline
                    "
                  >
                    Update
                  </jet-button> -->
                </div>
              </form>
            </div>
        
        <DxToast
          v-model:visible="isVisible"
          v-model:message="message"
          v-model:type="type"
        />


          </div>
        </div>
     </app-layout>
    </div>
  
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import { DxToast } from 'devextreme-vue/toast';
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";

const modelData = {};

export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    JetNavLink,
    JetButton,
    DxToast,
    MobileNavigation,
    MobileNavigationBack,

  },
  data: function () {
    return {
      title: this.moduleRoute + " Create",
      appbarTitle: this.moduleRoute + " Create",
      form: this.$inertia.form(),
      isVisible: false,
      message: '',
      type: 'success',
    };
  },
  methods: {
     showToast(message,type)
        {
          this.isVisible = true;
          this.message = message;
          this.type = type;
        },
    checkAction() {
      return this.modelData.hasOwnProperty("id") && this.modelData.id != "";
    },
    submit() {

      //console.log("Form Render",this.$refs.formRenderer.formData);
     this.form.post(
        route(this.moduleRoute + ".index", this.$refs.formRenderer.formData),
        {
          onComplete: this.showToast("Successfully completed", "success"),     
        }
      );

        
    },

    back() {
            this.$inertia.get('/'+this.moduleRoute);
    },
    

    update() {
      
        this.form.post(
                route(this.moduleRoute + ".update", this.$refs.formRenderer.formData),
                {
                  onSuccess: this.showToast("Successfully ", "success"),

                }
              );
    },checkMobile() {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    console.log("CheckMobile Called: Mobile");
                    return true;
                } else {
                  console.log("CheckMobile Called: Desktop");
                    return false;
                }
            },
  },
  mounted() {
        this.checkMobile();
   // console.log(this.modelData.hasOwnProperty("id"));
   // console.log("createDef");
    console.log("CreateDef",this.createDef);
    //  cnsole.log(this.moduleRoute + " Create",)
  },
};
</script>



<style>

.grey-background-container{
  background-color:#ffffff;
  height:100vh;
}

</style>